import { c as _c } from "react/compiler-runtime";
import type { LiveOrderBy } from '@module/apis/client-side/live/type';
import { useFetchLiveInfiniteQuery } from '@module/queries/live/liveQueryHooks';
import { useIntersectionObserver } from '@module/utils/useIntersectionObserver';
import TimeConstants from '../../utils/item';
const LIVE_LIST_CACHE_TIME = TimeConstants.ONE_MINUTE * 3;
interface Props {
  onlyNewBj: 'Y' | 'N';
  orderBy: LiveOrderBy;
  onlyRealTimeYN?: 'Y' | 'N'; // RT 대응 - 전환 후 삭제 예정
  limit?: number;
  refetchInterval?: number | false;
  globalSortYN?: 'Y' | 'N';
}
const useLiveViewModel = t0 => {
  const $ = _c(29);
  const {
    onlyNewBj,
    orderBy,
    onlyRealTimeYN: t1,
    limit: t2,
    refetchInterval: t3,
    globalSortYN: t4
  } = t0;
  const onlyRealTimeYN = t1 === undefined ? "N" : t1;
  const limit = t2 === undefined ? 24 : t2;
  const refetchInterval = t3 === undefined ? false : t3;
  const globalSortYN = t4 === undefined ? "N" : t4;
  let t5;
  if ($[0] !== globalSortYN || $[1] !== limit || $[2] !== onlyNewBj || $[3] !== onlyRealTimeYN || $[4] !== orderBy) {
    t5 = {
      orderBy,
      onlyNewBj,
      limit,
      onlyRealTimeYN,
      globalSortYN
    };
    $[0] = globalSortYN;
    $[1] = limit;
    $[2] = onlyNewBj;
    $[3] = onlyRealTimeYN;
    $[4] = orderBy;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== refetchInterval) {
    t6 = {
      staleTime: LIVE_LIST_CACHE_TIME,
      gcTime: LIVE_LIST_CACHE_TIME,
      refetchInterval
    };
    $[6] = refetchInterval;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  const {
    data,
    isLoading,
    isFetching,
    hasNextPage,
    fetchNextPage,
    refetch,
    hasPreviousPage,
    fetchPreviousPage
  } = useFetchLiveInfiniteQuery(t5, t6);
  let t7;
  if ($[8] !== hasNextPage) {
    t7 = () => hasNextPage;
    $[8] = hasNextPage;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== fetchNextPage || $[11] !== t7) {
    t8 = {
      isReadyToFetch: t7,
      onInView: fetchNextPage
    };
    $[10] = fetchNextPage;
    $[11] = t7;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  const {
    observerRef
  } = useIntersectionObserver(t8);
  let t9;
  if ($[13] !== hasPreviousPage) {
    t9 = () => hasPreviousPage;
    $[13] = hasPreviousPage;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== fetchPreviousPage) {
    t10 = () => {
      const mainContents = document.getElementById("main-contents");
      if (mainContents) {
        mainContents.scrollBy({
          top: 500
        });
      }
      fetchPreviousPage();
    };
    $[15] = fetchPreviousPage;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] !== t10 || $[18] !== t9) {
    t11 = {
      isReadyToFetch: t9,
      onInView: t10
    };
    $[17] = t10;
    $[18] = t9;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  const {
    observerRef: topObserverRef
  } = useIntersectionObserver(t11);
  let t12;
  if ($[20] !== data || $[21] !== fetchNextPage || $[22] !== hasNextPage || $[23] !== isFetching || $[24] !== isLoading || $[25] !== observerRef || $[26] !== refetch || $[27] !== topObserverRef) {
    t12 = {
      data,
      isLoading,
      isFetching,
      observerRef,
      refetch,
      topObserverRef,
      fetchNextPage,
      hasNextPage
    };
    $[20] = data;
    $[21] = fetchNextPage;
    $[22] = hasNextPage;
    $[23] = isFetching;
    $[24] = isLoading;
    $[25] = observerRef;
    $[26] = refetch;
    $[27] = topObserverRef;
    $[28] = t12;
  } else {
    t12 = $[28];
  }
  return t12;
};
export default useLiveViewModel;